// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/.pnpm/@umijs+react-refresh-webpack-plugin@0.5.11_react-refresh@0.14.0_webpack@5.108.4_lightningcss@1.32.0_postcss@8.5.19_/node_modules/@umijs/react-refresh-webpack-plugin/client/ReactRefreshEntry.js");
__webpack_require__("./node_modules/.pnpm/@umijs+bundler-webpack@4.6.79_typescript@5.9.3_webpack@5.108.4_lightningcss@1.32.0_postcss@8.5.19_/node_modules/@umijs/bundler-webpack/client/client/client.js");
var __webpack_exports__ = __webpack_require__("./src/.umi/umi.ts");
